// src/shared/services/apiBase.ts
// ─────────────────────────────────────────────────────────────────────────────
// Single shared RTK Query instance for the whole app, following RTK Query's
// own recommended code-splitting pattern: https://redux-toolkit.js.org/rtk-query/usage/code-splitting
//
// Every feature's API file calls `apiBase.injectEndpoints(...)` instead of its
// own `createApi(...)`. Because injection happens when the feature's module is
// evaluated — and feature pages are already lazy-loaded via the route registry —
// endpoints for a feature only enter the bundle (and the cache) when that
// feature is actually visited, instead of all ~50 feature APIs being wired into
// the store (and the entry bundle) eagerly at app startup.
//
// Only ONE reducer + ONE middleware needs to be registered in the store, no
// matter how many feature APIs get injected later.
//
// Add new tag types here when a feature needs one RTK Query doesn't already know
// about — injectEndpoints can't introduce new tag types on its own.
// ─────────────────────────────────────────────────────────────────────────────

import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../lib/api/baseQueryWithReauth";

export const apiBase = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "User",
    "BillingRateCard",
    "BillingCycle",
    "Complaint",
    "Business",
    "CurrentStatus",
    "GlobalUser",
    "AddressChange",
    "DocumentOwnerType",
    "DocumentType",
    "UserStage",
    "ApprovedUser",
    "UserDeactivate",
    "UserRole",
    "EmployeeType",
    "FuelType",
    "LineOfBusiness",
    "LkpAdhocWeekDay",
    "Department",
    "LkpFeedbackType",
    "LkpLocation",
    "LkpPenaltyType",
    "Process",
    "LkpTripType",
    "AdminMenu",
    "MenuPermission",
    "BillPlanType",
    "BillPlan",
    "Menu",
    "AppControl",
    "SosEscalation",
    "EventNotification",
    "Penalty",
    "GUserProfile",
    "MyReport",
    "MyReportPermission",
    "Role",
    "RoleMenuMapping",
    "Shift",
    "ShiftInterval",
    "ShiftManagement",
    "ShiftValidation",
    "SpecialCase",
    "CitySpeedProfile",
    "State",
    "Permission",
    "VehicleType",
    "VehicleStatus",
    "CityZone",
    "AdminDashboard",
    "UserAppConfiguration",
    "DriverAppConfig",
    "DriverEventConfig",
    "Location",
    "EscortVendors",
    "LOB",
    "Intervals",
    "Vendor",
    "Driver",
    "EhsChecks",
    "Vehicle",
    "MstShift",
  ],
  endpoints: () => ({}),
});
